export default "__VITE_ASSET__ClZ9VyDn__"